import { useState } from 'react';
import { shortAddress } from '../../utils/connectionConfig';
import Modal from '../modal/Modal';
import { useWallet } from '../wallet/WalletProvider';
import './ConnectButton.css';

/**
 * Кнопка одна. Без расширения (телефон, браузер без MetaMask) выбирать не из
 * чего — она сразу открывает WalletConnect. С расширением спрашивает способ:
 * на компьютере можно подписывать и телефоном по QR.
 */
const ConnectButton = () => {
  const {
    hasInjected,
    walletKind,
    detecting,
    address,
    isConnected,
    isCorrectChain,
    isKnownAdmin,
    busy,
    error,
    connect,
    switchChain,
    disconnect,
  } = useWallet();
  const [choosing, setChoosing] = useState(false);

  // Окно выбора закрывается до подключения: у WalletConnect своё окно, и два
  // модальных друг на друге перехватывали бы фокус и Escape.
  const connectVia = (via) => {
    setChoosing(false);
    connect(via);
  };

  const handleConnectClick = () => {
    if (hasInjected) setChoosing(true);
    else connect('walletconnect');
  };

  if (detecting) {
    return (
      <div className="connect">
        <button className="header__button" disabled>
          Поиск кошелька...
        </button>
      </div>
    );
  }

  return (
    <div className="connect">
      {isConnected ? (
        <button
          className="header__button"
          onClick={disconnect}
          title={`${address}\nНажмите, чтобы отключить кошелёк`}
        >
          {shortAddress(address)}
          {walletKind === 'walletconnect' && ' · WalletConnect'}
        </button>
      ) : (
        <button
          className="header__button"
          onClick={handleConnectClick}
          disabled={busy}
        >
          {busy ? 'Подключение...' : 'Подключить кошелёк'}
        </button>
      )}

      {choosing && (
        <Modal
          title="Подключение кошелька"
          onClose={() => setChoosing(false)}
          className="connect_choice"
        >
          <button
            className="connect_choice__option"
            onClick={() => connectVia('injected')}
          >
            <strong>MetaMask</strong>
            <span>Расширение в этом браузере</span>
          </button>
          <button
            className="connect_choice__option"
            onClick={() => connectVia('walletconnect')}
          >
            <strong>WalletConnect</strong>
            <span>Кошелёк на телефоне — по QR-коду</span>
          </button>
        </Modal>
      )}

      {isConnected && !isCorrectChain && (
        <button
          className="header__button connect__button--warning"
          onClick={switchChain}
          disabled={busy}
        >
          {busy ? 'Переключение...' : 'Переключить на BSC'}
        </button>
      )}

      {isConnected && !isCorrectChain && (
        <span className="connect__error">Кошелёк не в сети BSC</span>
      )}

      {isConnected && !isKnownAdmin && (
        <span className="connect__warning">Адрес не в списке админов</span>
      )}

      {error && <span className="connect__error">{error}</span>}
    </div>
  );
};

export default ConnectButton;
